var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownloadedList = function SvgIconDownloadedList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.5h1.59c.89 0 1.33 1.08.7 1.71L7.7 12.8a.996.996 0 0 1-1.41 0L1.7 8.21c-.63-.63-.18-1.71.71-1.71H4v-5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5Zm-9 11c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1H1Z",
    fill: "#8F8F9B"
  })));
};
export default SvgIconDownloadedList;